import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menu" ]
  static values = { open: Boolean, default: false }

  connect() {
    if (this.element.dataset.dropdownOpen === 'true') {
      this.openValue = true;
    } else {
      this.openValue = false;
    }
    this.updateMenuState()
  }

  toggle() {
    this.openValue = !this.openValue
    this.updateMenuState()
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
      this.updateMenuState()
    }
  }

  openValueChanged() {
    this.updateMenuState()
  }

  updateMenuState() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden");
      this.menuTarget.classList.add("block");
    } else {
      this.menuTarget.classList.remove("block");
      this.menuTarget.classList.add("hidden");
    }
  }
} 